var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page2Scores',{attrs:{"student":_vm.student,"itemRefPath":'schools/YJHjHWUGDok8teDhDIKX/xtodorhoilolt/pSPBHDgvioTxO1efDFnh',"ui_setting":_vm.ui_setting}})}
var staticRenderFns = []

export { render, staticRenderFns }